import { render, staticRenderFns } from "./AddNewCrmNotes.vue?vue&type=template&id=092a0d5c"
import script from "./AddNewCrmNotes.vue?vue&type=script&lang=js"
export * from "./AddNewCrmNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports